import { colors, colorSystem } from '@/styles/theme'
import { Radio as MRadio } from '@musinsa/mwms-ds'
import { ComponentProps } from 'react'
import styled, { css } from 'styled-components'
import { tokens } from '@musinsa/layer-tokens/desktop'

type Props = ComponentProps<typeof MRadio> & {
  disabled?: boolean
}

/**
 *  MWMS-DS 에서 제공하는 Radio는 yellow color
 *  이를 오버라이딩하여 PBO accent 블루로 랩핑
 */
export function Radio({ ...props }: Props) {
  return <MRadioWrap {...props} />
}

const MRadioWrap = styled(MRadio)`
  &:has(input:checked)::before {
    border-color: ${tokens.layerDesktop['border-accent']} !important;
  }

  &:has(input:checked)::after {
    background-color: ${tokens.layerDesktop['bg-accent']} !important;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      &::before {
        border-color: ${colors.gray400} !important;
        background-color: ${colors.gray200} !important;
      }

      &:has(input:checked)::before {
        border-color: ${colors.gray400} !important;
        background-color: ${colors.gray200} !important;
      }

      &:has(input:checked)::after {
        background-color: ${colors.gray600} !important;
      }

      & > span {
        color: ${colorSystem.text.common.tertiary} !important;
      }
    `}
`
